import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { validUrlValidator } from './valid-url.validator';

export const relevantInputValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const tab = control.get('tab');
  const url = control.get('url');
  const spreadsheetId = control.get('spreadsheetId');
  const worksheetId = control.get('worksheetId');

  const errors: { sheetSelection?: true; invalidName?: true; invalidUrl?: true } = {};

  if (tab?.value === 'OneDrive' || tab?.value === 'SharePoint') {
    if (!spreadsheetId?.value || !worksheetId?.value) {
      errors.sheetSelection = true;
    }
  }

  if (tab?.value === 'By URL') {
    if (!url?.value) {
      errors.invalidUrl = true;
    } else {
      const urlValidationError = validUrlValidator(url);
      if (urlValidationError) {
        errors.invalidUrl = true;
      }
    }
  }

  return Object.keys(errors).length ? errors : null;
};
